import { render, staticRenderFns } from "./ExhibitorList.vue?vue&type=template&id=62073b38"
import script from "./ExhibitorList.vue?vue&type=script&lang=ts"
export * from "./ExhibitorList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports